import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse<{ primary_organization_uuid: string | null }>>;

const updatePrimaryOrganization = (primaryOrganizationUuid: string | null): ReturnType => {
    return Request.put('/users/primary-organization', {
        primary_organization_uuid: primaryOrganizationUuid,
    });
};

export default updatePrimaryOrganization;
